import React from "react";
import DatePicker from "react-datepicker";
import DateTimeHelper from "shared/utils/dateTimeHelper";
import { DateTimePickerConfig } from "../types";
import { YEAR_SELECTOR_ID } from "shared/utils/constants";

export default function useDatePickerService(props: DateTimePickerConfig) {
  const ref = React.useRef<DatePicker>(null);
  const [timePickerRefreshKey, setTimePickerRefreshKey] = React.useState(0);

  const dateTimeFormat = React.useMemo(
    () => DateTimeHelper.getFormatString(props.formattingOptions),
    [props.formattingOptions]
  );

  const showTimeInput = React.useMemo(
    () => props.formattingOptions?.showTime || props.formattingOptions?.showOnlyTime,
    [props.formattingOptions?.showOnlyTime, props.formattingOptions?.showTime]
  );

  const closeOnScrollHandler = React.useCallback((e: any) => {
    if (
      e.target.classList?.value?.includes("selectDropdown__menu-list") ||
      e.target.classList?.value?.includes("scrollableTimePicker")
    ) {
      // It is Time Selector scroll, so don't close
      return false;
    }
    return (e.target?.id || "") !== YEAR_SELECTOR_ID;
  }, []);

  const closeDatePickerHandler = React.useCallback(() => {
    ref.current?.setOpen(false);
  }, []);

  const openDatePickerHandler = React.useCallback(() => {
    ref.current?.setOpen(true);
  }, []);

  const changeHandler = React.useCallback(
    (date: Date | null, event?: any) => {
      let updatedDate = date ? new Date(date) : null;
      let refreshTimePicker = false;
      if (props.isEndDate && updatedDate) {
        if (event?.type === "change") {
          //When end date is pasted: we need to set seconds to 59
          updatedDate.setSeconds(59, 999);
          refreshTimePicker = true;
        } else if (!props.selected) {
          //When end date is selected for first time then we need to set time to 11.59.59
          updatedDate.setHours(23, 59, 59, 999);
          refreshTimePicker = true;
        }
      }
      props.onChange(updatedDate, event);
      if (refreshTimePicker) {
        setTimePickerRefreshKey(key => key + 1);
      }
    },
    [props]
  );

  return {
    ref,
    dateTimeFormat,
    showTimeInput,
    timePickerRefreshKey,
    changeHandler,
    closeOnScrollHandler,
    closeDatePickerHandler,
    openDatePickerHandler
  };
}
